<button (click)="onBack()" class="btn-back mb-6" mat-icon-button>
    <mat-icon>arrow_back</mat-icon>
</button>

<!-- TODO: Update Angular Material Typography H2 -->
<div [ngClass]="pageTitleCss" class="mb-5 font-montserrat text-2xl font-bold">{{ pageTitle }}</div>
